// Base
import Image from 'next/image'
import Link from 'next/link'

// Components
import { Container, Box, Flex, Text, Button } from 'yard-utilities/components'
import Section from '@components/v25/section/Section'
import RecentDealCard from '@components/v25/cards/recent-deal/RecentDealCard'

// Assets
import GuaranteeBadge from '@images/v25/badges/best-price-guarantee.svg'

// Data
import deals from '@data/v25/deals.json'

interface RecentDealsProps {
  redirectURL: string
}

const RecentDeals = ({ redirectURL }: RecentDealsProps) => {
  return (
    <Section padding={[64, 0]}>
      <Box>
        <Text
          tagName="h2"
          variant="title-2"
          align="center"
          transform="capitalize"
          spacing={{ sm: 8 }}
        >
          TOP 3 Recent deals
        </Text>
        <Text tagName="p" variant="body-1" align="center" spacing={{ sm: 32 }}>
          Save <b>$287</b> per deal on average
        </Text>

        <Container>
          <Flex flexDirection="column" rowGap={{ sm: 16 }} spacing={{ sm: 32 }}>
            {deals.slice(0, 3).map((deal, index) => (
              <RecentDealCard {...deal} key={index} />
            ))}
          </Flex>
        </Container>
      </Box>

      <Box padding={{ sm: [0, 16] }}>
        <Text tagName="p" variant="body-1" align="center" spacing={{ sm: 32 }}>
          Most deals are <strong>60-90%</strong> off the normal price. We will
          only send you the most heavily discounted flight deals from your
          location.
        </Text>
      </Box>

      <Flex flexDirection="column" center rowGap={{ sm: 32 }}>
        <Button as={Link} href={redirectURL} variant="yellow-sm-shadow">
          start now
        </Button>

        <Image
          src={GuaranteeBadge}
          alt="Best price guarantee badge"
          width={181}
          height={48}
          priority
        />
      </Flex>
    </Section>
  )
}

export default RecentDeals
